import SchedulerManagerPage from '../pages/SchedulerManager/SchedulerManagerPage'

export const SCHEDULER_MANAGER_PATH = '/scheduler'

export const SCHEDULER_MANAGER_ROUTES = [
	{
		path: SCHEDULER_MANAGER_PATH,
		element: <SchedulerManagerPage />,
	},
]
